export default __webpack_public_path__ + "static/media/5_PRESTIGIO_OPERA_120x278_265.5f0a9c79.jpg";